{
  "hero": {
    "title": "Contact"
  },
  "intro": {
    "text": "Hai să colaborăm! Fie că ai nevoie de videoclipuri, design-uri sau soluții digitale, sunt doar la un mesaj distanță. Completează formularul de mai jos sau contactează-mă direct — abia aștept să aud despre proiectul tău."
  },
  "form": {
    "title": "Trimite-mi un mesaj",
    "fields": {
      "fullName": {
        "label": "Nume complet"
      },
      "email": {
        "label": "Email"
      },
      "message": {
        "label": "Mesaj"
      }
    },
    "submit": "Trimite mesaj"
  },
  "direct": {
    "title": "Sau contactează-mă direct",
    "email": {
      "label": "Email: octavian@khromatik.com",
      "tooltip": "Copiază email"
    }
  }
}

